// extracted by mini-css-extract-plugin
export var content = "G5Lj8";